import React, {useState} from 'react'

//Node Modules
import { useTranslation } from 'react-i18next'
import { TopIcon, BottomIcon } from 'components/SASIcon'


//Styles
import styles from './Item.module.scss'

interface Props {
  menuItems: React.ReactNode[]
}

const LimitedMenu = ({menuItems}:Props) => {
  const { t } = useTranslation()
  const [showMenu, setShowMenu] = useState<boolean>(false)

  const handleKeyboard = (e: React.KeyboardEvent) => {
    if (e.keyCode === 32 || e.keyCode === 13) {
      let target = e.currentTarget as HTMLElement 
      target.click()
    }
  }

  const toggleMenu = (e: React.MouseEvent) => {
    setShowMenu(!showMenu)
    let parent= document.getElementById('Version-Picker-Menu')?.parentElement
    parent?.classList.toggle('expanded')
  }

  window.addEventListener('version-picker-close', () => {
    setShowMenu(false)
  }) 

  const toggleBtn = <a className={`${styles.item} dropdown-item ${styles.toggleBtn}`} onClick={toggleMenu} onKeyDown={handleKeyboard} tabIndex={0}>{t('helpcenter-gui-icu.content.version.menu.limited_support.label')}<span className={styles.iconContainer}>{showMenu ? <TopIcon />: <BottomIcon />}</span></a>/* eslint-disable-line */
 
  return (<>
    {toggleBtn}
    {
    showMenu ?
    <div className='unsupportedMenu'>
      {menuItems}
    </div> : <></>
    }
    

  </>)
}

export default LimitedMenu